type Analytics = {event: (name: string, params: Record<string, unknown>, onceKey?: string) => boolean; user: (id: number | null) => void};
function whenReady(callback: (analytics: Analytics) => void) {
  if (typeof window === 'undefined') return;
  const run=()=>{const analytics=(window as Window & {v6Analytics?: Analytics}).v6Analytics; if(analytics) callback(analytics);};
  if((window as Window & {v6Analytics?: Analytics}).v6Analytics) run();
  else document.addEventListener('v6:analytics-ready',run,{once:true});
}
export function ga4Event(name:string,params:Record<string,unknown>={},onceKey?:string){whenReady(analytics=>analytics.event(name,params,onceKey));}
export function ga4User(id:number|null){whenReady(analytics=>analytics.user(id));}
